export const FileAcceptTypes = {
  DOCUMENT: 'application/pdf, image/jpeg, image/png',
  IMAGE: 'image/jpeg, image/png'
}

// Максимальный размер файла в байтах (4 МБ - ограничение gRPC)
export const MAX_FILE_SIZE = 4 * 1024 * 1024;
